import ReactGA from 'react-ga';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { UserContextProvider } from '@incentivegames/ig-frontend-common/lib/contexts/UserContextProvider';
import { StorageContextProvider } from '@incentivegames/ig-frontend-common/lib/contexts/StorageContextProvider';
import { ErrorBoundary } from '@incentivegames/ig-component-common';
import { gaUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/gaUtilities';
import { GaCategories } from '@incentivegames/ig-types/lib/enums/gaCatagories/gaCategories';

import i18n from './theme/i18n';
import Config from './theme/config';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './index.scss';
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorPopupProvider } from './contexts/ErrorPopupContext';

const onError = (error: any, info: any) => {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE || '', { debug: false });

  // The Error and info vars can be both objects and string -
  // - the below logic is so we only extracts strings.
  let errorString = 'react errorBoundary - unset';
  let infoString = 'react errorBoundary - unset ';
  if (typeof error === 'string') errorString = error;
  if (typeof error.stack === 'string') errorString = error.stack;
  if (typeof info === 'string') infoString = info;
  if (typeof info.componentStack === 'string') infoString = info.stack;
  console.error(error, info);
  gaUtilities.recordEventGA(GaCategories.error, errorString, infoString);
};
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <I18nextProvider i18n={i18n}>
      <StorageContextProvider
        storageType={Config.settings.storageType}
        isDevelopmentEnvironment={process.env.REACT_APP_SITE_ENV === 'dev'}
      >
        <UserContextProvider
          config={{
            tokenCookieName: Config.settings.tokenCookieName,
            tokenFromParentType: Config.settings.tokenFromParentType,
            languageCodeIdentifier: Config.settings.languageCodeIdentifier,
            languageFromParentType: Config.settings.languageFromParentType,
            supportedLanguages: Config.settings.supportedLanguages,
            defaultLanguage: Config.settings.defaultLanguage,
            currencyCodeIdentifier: Config.settings.currencyCodeIdentifier,
            currencyFromParentType: Config.settings.currencyFromParentType,
            defaultCurrency: Config.settings.defaultCurrency,
            supportedCurrencies: Config.settings.supportedCurrencies,
          }}
        >
          <ErrorBoundary
            onError={onError}
            wrapperBackgroundColor='#fff'
            wrapperMargin='10px'
            messagePadding='5px'
            messageTextAlign='center'
            errorTextColor='black'
            customErrorMessage={'Something has gone wrong, please try again later.'}
          >
            <ErrorPopupProvider>
              <App />
            </ErrorPopupProvider>
          </ErrorBoundary>
        </UserContextProvider>
      </StorageContextProvider>
    </I18nextProvider>
  </QueryClientProvider>,
  document.getElementById('root'),
);
serviceWorker.unregister();
